export const logos = {
  gmail: 'https://cdn.heroengage.com/assets/logos/gmail-share-icon.svg',
  instagram: 'https://cdn.heroengage.com/assets/logos/instagram-share-icon.svg',
  linkedin: 'https://cdn.heroengage.com/assets/logos/linkedin-share-icon.svg',
  messenger: 'https://cdn.heroengage.com/assets/logos/messenger-share-icon.svg',
  outlook: 'https://cdn.heroengage.com/assets/logos/outlook-share-icon.svg',
  telegram: 'https://cdn.heroengage.com/assets/logos/telegram-share-icon.svg',
  whatsapp: 'https://cdn.heroengage.com/assets/logos/whatsapp-share-icon.svg'
};
